import { render, staticRenderFns } from "./TasksList.vue?vue&type=template&id=ff428046&"
import script from "./TasksList.vue?vue&type=script&lang=ts&"
export * from "./TasksList.vue?vue&type=script&lang=ts&"
import style0 from "./TasksList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports